<div class="recurrence-editor">
  @if (showPatternDetails()) {
    <div class="row recurrence-editor__row recurrence-editor__row--primary">
      <div class="field field--frequency">
        <label class="field__label">{{
          translation.reservationPopup.recurrenceEditorMessages.repeat | transloco
        }}</label>
        <assist-dropdownlist
          [formControl]="recurrenceForm.controls.frequency"
          [data]="frequencies()"
          textField="label"
          valueField="value"
          [valuePrimitive]="true"
          [popupSettings]="{ appendTo: 'component' }"
        />
      </div>
      <div class="field field--interval">
        <label class="field__label">
          @if (isWeekly()) {
            {{ translation.reservationPopup.recurrenceEditorMessages.weeklyRepeatEvery | transloco }}
          } @else if (isMonthly()) {
            {{ translation.reservationPopup.recurrenceEditorMessages.monthlyRepeatEvery | transloco }}
          } @else if (isYearly()) {
            {{ translation.reservationPopup.recurrenceEditorMessages.yearlyRepeatEvery | transloco }}
          } @else {
            {{ translation.reservationPopup.recurrenceEditorMessages.dailyRepeatEvery | transloco }}
          }
        </label>
        <assist-textbox
          class="field__textbox field__textbox--number"
          [formControl]="recurrenceForm.controls.interval"
        />
      </div>
      <div class="field field--suffix">
        <div class="field__label field__label--spacer" aria-hidden="true"></div>
        <span class="field__hint">
          @if (isWeekly()) {
            {{ translation.reservationPopup.recurrenceEditorMessages.weeklyInterval | transloco }}
          } @else if (isMonthly()) {
            {{ translation.reservationPopup.recurrenceEditorMessages.monthlyInterval | transloco }}
          } @else if (isYearly()) {
            {{ translation.reservationPopup.recurrenceEditorMessages.yearlyInterval | transloco }}
          } @else {
            {{ translation.reservationPopup.recurrenceEditorMessages.dailyInterval | transloco }}
          }
        </span>
      </div>
    </div>
  } @else {
    <div class="row recurrence-editor__row recurrence-editor__row--frequency">
      <div class="field">
        <label class="field__label">{{
          translation.reservationPopup.recurrenceEditorMessages.repeat | transloco
        }}</label>
        <assist-dropdownlist
          [formControl]="recurrenceForm.controls.frequency"
          [data]="frequencies()"
          textField="label"
          valueField="value"
          [valuePrimitive]="true"
          [popupSettings]="{ appendTo: 'component' }"
        />
      </div>
    </div>
  }

  @if (showPatternDetails()) {
    @if (isWeekly()) {
      <div class="row recurrence-editor__row">
        <div class="field">
          <label class="field__label">{{
            translation.reservationPopup.recurrenceEditorMessages.weeklyRepeatOn | transloco
          }}</label>
          <div class="weekday-grid">
            @for (day of dayOptions(); track day.value) {
              <button
                type="button"
                class="weekday-chip"
                [ngClass]="{ 'weekday-chip--active': isWeekdaySelected(day.value) }"
                (click)="toggleWeekday(day.value)"
              >
                {{ day.label }}
              </button>
            }
          </div>
        </div>
      </div>
    }

    @if (isMonthly()) {
      <div class="row recurrence-editor__row recurrence-editor__row--split">
        <label class="field__label field__label--inline">{{
          translation.reservationPopup.recurrenceEditorMessages.monthlyRepeatOn | transloco
        }}</label>
        <div class="mode-switch">
          <button
            type="button"
            class="mode-switch__item"
            [ngClass]="{ 'mode-switch__item--active': isMonthlyAbsolute() }"
            (click)="recurrenceForm.controls.monthlyMode.setValue('absolute')"
          >
            {{ translation.reservationPopup.recurrenceEditorMessages.monthlyDay | transloco }}
          </button>
          <button
            type="button"
            class="mode-switch__item"
            [ngClass]="{ 'mode-switch__item--active': !isMonthlyAbsolute() }"
            (click)="recurrenceForm.controls.monthlyMode.setValue('relative')"
          >
            {{ translation.reservationPopup.recurrenceEditorMessages.weeklyRepeatOn | transloco }}
          </button>
        </div>
      </div>

      @if (isMonthlyAbsolute()) {
        <div class="row recurrence-editor__row">
          <div class="field field--day-of-month">
            <label class="field__label">{{
              translation.reservationPopup.recurrenceEditorMessages.monthlyDay | transloco
            }}</label>
            <div class="field__readonly">{{ startDayOfMonth() }}</div>
          </div>
        </div>
      } @else {
        <div class="row recurrence-editor__row recurrence-editor__row--split">
          <div class="field">
            <label class="field__label">{{
              translation.reservationPopup.recurrenceEditorMessages.monthlyRepeatOn | transloco
            }}</label>
            <div class="field__readonly">{{ startWeekIndexLabel() }}</div>
          </div>
          <div class="field">
            <div class="field__label field__label--spacer" aria-hidden="true"></div>
            <div class="field__readonly">{{ startWeekdayLabel() }}</div>
          </div>
        </div>
      }
    }

    @if (isYearly()) {
      <div class="row recurrence-editor__row recurrence-editor__row--split">
        <label class="field__label field__label--inline">{{
          translation.reservationPopup.recurrenceEditorMessages.yearlyRepeatOn | transloco
        }}</label>
        <div class="mode-switch">
          <button
            type="button"
            class="mode-switch__item"
            [ngClass]="{ 'mode-switch__item--active': isYearlyAbsolute() }"
            (click)="recurrenceForm.controls.yearlyMode.setValue('absolute')"
          >
            {{ translation.reservationPopup.recurrenceEditorMessages.monthlyDay | transloco }}
          </button>
          <button
            type="button"
            class="mode-switch__item"
            [ngClass]="{ 'mode-switch__item--active': !isYearlyAbsolute() }"
            (click)="recurrenceForm.controls.yearlyMode.setValue('relative')"
          >
            {{ translation.reservationPopup.recurrenceEditorMessages.weeklyRepeatOn | transloco }}
          </button>
        </div>
      </div>

      @if (isYearlyAbsolute()) {
        <div class="row recurrence-editor__row recurrence-editor__row--split">
          <div class="field">
            <label class="field__label">{{
              translation.reservationPopup.recurrenceEditorMessages.yearlyOf | transloco
            }}</label>
            <div class="field__readonly">{{ startMonthLabel() }}</div>
          </div>
          <div class="field">
            <label class="field__label">{{
              translation.reservationPopup.recurrenceEditorMessages.monthlyDay | transloco
            }}</label>
            <div class="field__readonly">{{ startDayOfMonth() }}</div>
          </div>
        </div>
      } @else {
        <div class="row recurrence-editor__row recurrence-editor__row--triple">
          <div class="field">
            <label class="field__label">{{
              translation.reservationPopup.recurrenceEditorMessages.yearlyOf | transloco
            }}</label>
            <div class="field__readonly">{{ startMonthLabel() }}</div>
          </div>
          <div class="field">
            <div class="field__label field__label--spacer" aria-hidden="true"></div>
            <div class="field__readonly">{{ startWeekIndexLabel() }}</div>
          </div>
          <div class="field">
            <div class="field__label field__label--spacer" aria-hidden="true"></div>
            <div class="field__readonly">{{ startWeekdayLabel() }}</div>
          </div>
        </div>
      }
    }

    <div class="row recurrence-editor__row recurrence-editor__row--end">
      <label class="field__label">{{
        translation.reservationPopup.recurrenceEditorMessages.endLabel | transloco
      }}</label>
      <div class="end-options">
        <label class="end-options__item">
          <input type="radio" name="rangeType" [formControl]="recurrenceForm.controls.rangeType" value="on" />
          <span>{{ translation.reservationPopup.recurrenceEditorMessages.endOn | transloco }}</span>
        </label>
        @if (isRangeOn()) {
          <assist-datepicker
            class="end-options__datepicker"
            [formControl]="recurrenceForm.controls.endDate"
            [appendTo]="'component'"
            [max]="maxEndDate()"
            [format]="'M/d/yyyy'"
          />
        }
        <label class="end-options__item">
          <input type="radio" name="rangeType" [formControl]="recurrenceForm.controls.rangeType" value="after" />
          <span>{{ translation.reservationPopup.recurrenceEditorMessages.endAfter | transloco }}</span>
        </label>
        @if (isRangeAfter()) {
          <div class="end-options__after">
            <assist-textbox
              class="field__textbox field__textbox--short"
              [formControl]="recurrenceForm.controls.occurrences"
            />
            <span class="field__hint end-options__after-label">{{
              translation.reservationPopup.recurrenceEditorMessages.endOccurrence | transloco
            }}</span>
          </div>
        }
        <label class="end-options__item">
          <input type="radio" name="rangeType" [formControl]="recurrenceForm.controls.rangeType" value="never" />
          <span>{{ translation.reservationPopup.recurrenceEditorMessages.endNever | transloco }}</span>
        </label>
      </div>
    </div>
  }
</div>
